

import React, {Component} from 'react';
import HotelItem from './hotel_item.component';
import ModalHotelFilter from './modal_hotel_filter.component ';


class HotelsList extends Component {

  state = {
      redirect : null,
      showSearchFilter: false
  }

  componentDidMount = () => {
    console.log('HotelsList componentDidMount props', this.props);
    this.forceUpdate();
  }



  setModalFilterClosed = () => {        
    this.setState({showSearchFilter:false}); 
  }

  
  setModalFilterOpened = () => {       
    console.log('HotelsList setModalFilterOpened clicked');
    this.setState({showSearchFilter:true}); 

  }

  DisplayForHotelDetails = (hotelId) => {

    console.log('HotelsList DisplayForDetails hotelId', hotelId);
    this.props.DisplayForHotelDetails(hotelId);
  }

  searchFilterHotels = (data) => {

    console.log('HotelsList searchFilterHotels data', data);
    this.setState({showSearchFilter:false}); 
    this.props.searchFilterHotels(data);
  }

  render() { 

    const Hotels = this.props.hotelsList.map((h) =>
        <HotelItem  
          key={h.key} 
          hotel={h} 
          DisplayForHotelDetails={this.DisplayForHotelDetails}
          forOrder={this.props.forOrder} 
          
          />        
    );

    return (


      <React.Fragment >     

      {(this.state.showSearchFilter) ?
          <ModalHotelFilter  
            setModalFilterClosed={this.setModalFilterClosed}
            searchFilterHotels={this.searchFilterHotels} />    
      : null}
        

        <div className="cntered-flex">
            <div className="hotel_list_container">
                <div className="hotel_list_inner_bg">
                    <div className="hotel_list_top">                            
                        <div className="modal_order_title1"> רשימת בתי מלון</div>
                    </div>

                    
                    <div className="hp_search_results_middlePad">
                        <div className="hp_search_title2">
                            <div className="cntered-flex">

                            </div>
                        </div>
                    </div>

                    <div className="hotels_list_FilterPanel">
                        <div className="filter_btn" 
                            onClick={ () => this.setModalFilterOpened()}>
                            <img src={"/images/site/filter.png"} alt="" />  
                            <span>סנן</span>
                           
                        </div>
                    </div>
                    
                    <div className="hp_search_pad1_line"></div>
                    <div className="cntered-flex hotel_details_paddingTop30">
                        <div className="main_grid_container">
                            {Hotels}
                        </div>
                    </div>

                </div>
              </div>
          </div>

      </React.Fragment>
    )
  }
}

export default HotelsList;
